import { useState } from "react";
import { toast } from "sonner";
import "@/App.css";
import { Navigation } from "./components/Navigation";
import { HeroSection } from "./components/HeroSection";
import { SkillsSection } from "./components/SkillsSection";
import { StoresSection } from "./components/StoresSection";
import { RMCNetwork } from "./components/RMCNetwork";
import { ContactSection } from "./components/ContactSection";
import { SiteFooter } from "./components/SiteFooter";
import { ProjectDialog } from "./components/ProjectDialog";
import { AskAIWidget } from "./components/AskAIWidget";

function App() {
  const [coins, setCoins] = useState(42);
  const [selectedProject, setSelectedProject] = useState(null);

  const handleCoinCollect = () => {
    setCoins((c) => c + 1);
    toast.success("+1 Coin Collected!", { duration: 2000 });
  };

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-[hsl(var(--background))] font-body">
      <Navigation coins={coins} onCoinCollect={handleCoinCollect} onNavigate={scrollToSection} />
      <HeroSection onNavigate={scrollToSection} />
      <SkillsSection />
      <StoresSection onProjectClick={setSelectedProject} />
      <RMCNetwork />
      <ContactSection />
      <SiteFooter onNavigate={scrollToSection} />
      <ProjectDialog project={selectedProject} onClose={() => setSelectedProject(null)} />
      <AskAIWidget />
    </div>
  );
}

export default App;
